import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Category} from '../Models/category';
import {Response} from "../Models/response";
import {AuthService} from "../components/pages/Account/Service/auth.service";


@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  baseUrl = environment.apiUrl + '/Categories';
   httpHeaders: HttpHeaders;

  constructor(private http: HttpClient ,authService: AuthService) {
      this.httpHeaders = new HttpHeaders({
          Authorization: `Bearer ${authService.getTokenAuth()}`,
      });
  }

  getAllCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${this.baseUrl}/GetAll`, {
      headers: this.httpHeaders,
    });
  }

  getCategory(categoryId: string): Observable<Response<Category>> {
    return this.http.get<Response<Category>>(`${this.baseUrl}/Get/${categoryId}`,{
        headers: this.httpHeaders,
    });
  }

}
